
import { combineReducers } from "redux";
import UhaulReducer from "./UhaulReducer";
import { FlexReducer,  } from "@twilio/flex-ui";

// class MyStoreState implements Flex.FlexState {
//     myApp: any;
//     flex: any;
// }

export default combineReducers({
    FlexReducer,
    UhaulReducer
});